import React from 'react'

import { Card } from '@newComponents/Card'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocStep } from '../shared/DocStep'

const GoogleCalendar = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Guild supports per-user Google Calendar sync via OAuth. When you
        connect your Google Calendar, Events you RSVP to are automatically
        added to your calendar. If Event details change — such as the date,
        time, or venue — your calendar entry updates to match.
      </Paragraph>
      <Paragraph size='$5'>
        This is a personal setting, not a Guild-level configuration. Each user
        connects their own Google Calendar independently from their user
        Settings.
      </Paragraph>
      {/* TODO: Capture screenshot of user Settings → Calendar section showing the Google Calendar connection */}
    </Card>

    <Card gap='$4'>
      <DocSection id='connecting-google-calendar' title='Connecting Google Calendar'>
        <DocStep
          number={1}
          title='Open your user Settings'
          description='Click your profile photo in the navigation bar and go to Settings.'
        />
        <DocStep
          number={2}
          title='Navigate to the Calendar section'
          description='In your Settings, find the Calendar section.'
        />
        <DocStep
          number={3}
          title='Click Connect Google Calendar'
          description="Click the Connect Google Calendar button. You'll be redirected to Google's OAuth consent screen."
        />
        <DocStep
          number={4}
          title='Approve access'
          description='Review the requested permissions and approve. Guild only creates and updates calendar entries for Events you RSVP to — it does not read or modify your existing calendar entries.'
        />
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='how-sync-works' title='How Sync Works'>
        <Paragraph size='$5'>
          Once connected, every{' '}
          <Link href='/docs/events/overview'>Event</Link> you RSVP to is synced
          to your Google Calendar automatically. The calendar entry includes the
          Event name, date and time, venue details, and a link back to the Event
          page on Guild.
        </Paragraph>
        <Paragraph size='$5'>
          Changes an Organizer makes to Event details — time, venue,
          description — are propagated to your calendar entry automatically. If
          you cancel your RSVP, the calendar entry is removed.
        </Paragraph>
        <Paragraph size='$5'>
          Google Calendar sync works across all Guilds you are a Member of. You
          do not need to configure it per Guild — once connected, RSVPs from any
          Guild will appear in your calendar.
        </Paragraph>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='calendar-feeds-alternative' title='Alternative: Calendar Feeds'>
        <Paragraph size='$5'>
          For a lighter alternative that doesn't require connecting a Google
          account, see{' '}
          <Link href='/docs/guilds/calendar-feeds'>Calendar Feeds</Link>.
          Calendar Feeds provide an iCal URL you can subscribe to from any
          calendar app — including Google Calendar, Apple Calendar, and Outlook —
          without granting OAuth access. Feeds show all of a Guild's upcoming
          Events rather than just the ones you've RSVPed to.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default GoogleCalendar
